import { j as o } from "./jsx-runtime-C5mzlN2N.js";
import { forwardRef as u } from "react";
import l from "styled-components";
import "./components/Theme/themes.es.js";
import "./palettes-Bw24w7AF.js";
import { getRadii as h, getPaletteForeground as x } from "./components/Theme/utils.es.js";
import "./CssBaseline-Bp4jdUgb.js";
import { sizeStyles as y, variantStyles as $, iconSizeStyles as g } from "./components/Button/styles.es.js";
import "./styles-DaQVIHg4.js";
import { T as z } from "./Typography-CGn3dGWy.js";
const S = {
  xs: "xs",
  sm: "sm",
  md: "sm",
  lg: "md",
  xl: "md",
  "2xl": "lg"
}, j = l.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;

  border-radius: ${h("full")};

  ${(t) => y[t.$size]};
  ${(t) => $[t.$variant]};

  &:disabled {
    cursor: not-allowed;

    color: ${x("disabled.default")};
  }
`, s = l.div`
  display: inline-flex;

  ${(t) => g[t.$size]}

  > svg {
    width: inherit;
    height: inherit;
  }
`, _ = u(
  function(d, m) {
    const {
      color: a = "brand",
      size: i = "md",
      variant: c = "contained",
      children: e,
      startAdornment: r,
      endAdornment: n,
      ...p
    } = d, f = S[i];
    return /* @__PURE__ */ o.jsxs(
      j,
      {
        ref: m,
        $color: a,
        $size: i,
        $variant: c,
        ...p,
        children: [
          r && /* @__PURE__ */ o.jsx(s, { $size: i, children: r }),
          typeof e == "string" ? /* @__PURE__ */ o.jsx(
            z,
            {
              color: "inherit",
              weight: "semibold",
              size: f,
              children: e
            }
          ) : e,
          n && /* @__PURE__ */ o.jsx(s, { $size: i, children: n })
        ]
      }
    );
  }
);
export {
  _ as B
};
